import { Grid, Paper, Table, TableCell, TableContainer, TableRow } from '@mui/material';
import { muiTheme } from '@styles/muiTheme';
import { formatCurrency, formatDate } from '@shared/commonFunctions';
import { SectionTitle } from '@shared/components/SectionTitle';
import { IDSProps } from '../interfaces';

export const DealSheetHeader = ({ data: dealsheet }: IDSProps) => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={3}
        sm={12}
      >
        <SectionTitle
          title={`VIN: ${dealsheet?.vin?.toUpperCase()}`}
          variant="h2"
          color={muiTheme.palette.success.main}
          marginTop={0}
        />
      </Grid>
      <Grid
        item
        md={9}
        sm={12}
      >
        <TableContainer component={Paper}>
          <Table
            size="small"
            aria-label="a dense table"
            sx={{ border: 1, borderColor: muiTheme.palette.grey[600] }}
          >
            <TableRow>
              <TableCell>
                <strong>LC</strong>
              </TableCell>
              <TableCell align="left">{dealsheet?.lcName}</TableCell>
              <TableCell>
                <strong>Lender</strong>
              </TableCell>
              <TableCell align="left">{dealsheet?.lenderName}</TableCell>
              <TableCell>
                <strong>Payoff Source</strong>
              </TableCell>
              <TableCell align="left">{dealsheet?.payoffSource}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Created</strong>
              </TableCell>
              <TableCell align="left">{formatDate(dealsheet?.createdDate)}</TableCell>
              <TableCell>
                <strong>Funded</strong>
              </TableCell>
              <TableCell align="left">{formatDate(dealsheet?.fundedDate)}</TableCell>
              <TableCell>
                <strong>Deal Amount Financed</strong>
              </TableCell>
              <TableCell align="left">{formatCurrency(dealsheet?.cudlAmountFinanced)}</TableCell>
            </TableRow>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
